import { render, staticRenderFns } from "./AutomationSetting.vue?vue&type=template&id=68706c7d&scoped=true"
import script from "./AutomationSetting.vue?vue&type=script&lang=js"
export * from "./AutomationSetting.vue?vue&type=script&lang=js"
import style0 from "./AutomationSetting.vue?vue&type=style&index=0&id=68706c7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68706c7d",
  null
  
)

export default component.exports